import { ActionTypes }         from '../actions/types';
import { componentsStateType } from 'reducer/types';


export const initialComponentsState: componentsStateType = {
    sender:                  '',
    lang:                    'heb',
    searchStr:               '',
    groupSearchStr:          '',
    selectedGrades:          '1234567',
    selectedAppTopic:        '',
    selectedAppSubTopic:     '',
    selectedContent:         'bigContentArr',
    appUrl:                  '',
    followLink:              '',
    disabledGrades:          '',
    showNavBar:              true,
    showMenu:                false,
    showSmallMenu:           false,
    showAppIframe:           false,
    showSidebarWhatsapp:     true,
    openGradeGrid:           false,
    openGroupMenu:           false,
    enableGroupSearchButton: false,
    enableGroupLinkButton:   false,
    showAppIntro:            false,
    showVideoIframe:         false,
    createTopicArr:          true,
    showScreenRecorder:      false,
    showUserVideos:          false,
    showLoader:              false,
    appLessons:              [] as { [key: string]: any }[]
  };

const componentsReducer = (state = initialComponentsState, action: ActionTypes) => {

    switch (action.type) {

    case 'SET_COMPONENTS_STATE':
      {
        return {
          ...state,
          ...action.payload
        }
      }

      case 'SET_LANG':
      {
        return {
          ...state,
          lang: action.payload === 'heb' || action.payload === 'ara' ? action.payload : state.lang
        }

      }

      case 'SET_FOLLOW_LINK':
      {
        return {
          ...state,
          followLink: action.payload
        }

      }


    default: return state;
  }
};

export type reducerType = ReturnType<typeof componentsReducer>;

export { componentsReducer };

  